import { Component, inject, OnInit, signal } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { SynIconComponent, SynNavItemComponent, SynSideNavComponent } from '@synergy-design-system/angular';
import { getUserData } from '../../api/auth';

const NAV_BAR_OPEN_WIDTH = 'var(--nav-bar-open-width)';

export const NAV_BAR_MARGIN_CLOSED = {
  'margin-left': '0',
};

export const NAV_BAR_MARGIN_OPEN = {
  'margin-left': NAV_BAR_OPEN_WIDTH,
};

@Component({
  selector: 'app-side-nav',
  template: `
    <syn-side-nav
      [open]="true" [noFocusTrapping]="true"
      (synShowEvent)="onShowNav()"
      (synHideEvent)="onHideNav()"
    >
      <syn-nav-item
        routerLink="dashboard"
        routerLinkActive
        #dashboardRla="routerLinkActive"
        [current]="dashboardRla.isActive"
      >
        <syn-icon name="home_fill" slot="prefix" />
        <span i18n="@@dashboard">Dashboard</span>
      </syn-nav-item>

      @if (showCustomers()) {
        <syn-nav-item
          [divider]="true"
          routerLink="customers"
          routerLinkActive
          #customersRla="routerLinkActive"
          [current]="customersRla.isActive"
        >
          <syn-icon name="group_fill" slot="prefix" />
          <span i18n="@@customer-accounts">Customer Accounts</span>
        </syn-nav-item>
      }

      @if (showClients()) {
        <syn-nav-item
          [divider]="true"
          routerLink="clients"
          routerLinkActive
          #clientsRla="routerLinkActive"
          [current]="clientsRla.isActive"
        >
          <syn-icon name="settings_applications_fill" slot="prefix" />
          <span i18n="@@my-clients">My OIDC Clients</span>
        </syn-nav-item>
      }

      @if (showTestUsers()) {
        <syn-nav-item
          [divider]="true"
          routerLink="test-users"
          routerLinkActive
          #testUsersRla="routerLinkActive"
          [current]="testUsersRla.isActive"
        >
          <syn-icon name="groups_3_fill" slot="prefix" />
          <span i18n="@@my-test-users">My Test Users</span>
        </syn-nav-item>
      }

      <syn-nav-item
        [divider]="true"
        routerLink="client-list"
        routerLinkActive
        #clientListRla="routerLinkActive"
        [current]="clientListRla.isActive"
      >
        <syn-icon name="list_fill" slot="prefix" />
        <span i18n="@@all-clients">All SICK ID Clients</span>
      </syn-nav-item>
    </syn-side-nav>
  `,
  styles: [
    `
      syn-side-nav::part(overlay) {
        display: none;
      }
    `,
  ],
  imports: [
    RouterLink,
    RouterLinkActive,
    SynIconComponent,
    SynNavItemComponent,
    SynSideNavComponent,
  ],
})
export class SideNavComponent implements OnInit {
  contentStyle = signal(NAV_BAR_MARGIN_OPEN);

  showCustomers = signal(false);
  showClients = signal(false);
  showTestUsers = signal(false);
  showClientList = signal(false);

  ngOnInit(): void {
    const user = getUserData();

    this.showCustomers.set(user.roles.includes('sickid_usermanager')
      || user.roles.includes('sickid_usermanager_admin'));
    // It is no longer required to have the 'client_managers' role
    // If a user has permissions for any client, they should see them.
    this.showClients.set(true);
    this.showTestUsers.set(user.roles.includes('test_user_manager'));
    this.showClientList.set(user.sickEmployee);
  }


  onShowNav() {
    this.contentStyle.set(NAV_BAR_MARGIN_OPEN);
  }

  onHideNav() {
    this.contentStyle.set(NAV_BAR_MARGIN_CLOSED);
  }
}
